module.exports = __webpack_public_path__ + "static/media/manguera-gris.0253af79.svg";